import { createTheme } from '@mui/material/styles';
import { yellow } from '@mui/material/colors';

export const theme = createTheme({
  palette: {
    primary: yellow,
  },
});
